// components/AI/ImageLightbox.js
// Penampil gambar layar penuh untuk lampiran chat.
//
// Dipakai DUA tempat: transkrip hidup (components/AI/AIChat.js) dan halaman
// riwayat (pages/AIChatHistory.js). Dijadikan komponen bersama sejak awal —
// bukan disalin — karena keduanya membaca bentuk data yang sama
// (`data_json.images`), sehingga setiap perubahan bentuk akan menuntut dua
// suntingan serempak. Alasan yang sama sudah membuat sessionResume.js dipisah.
//
// Sumber gambar: `preview` (640px) bila ada, jatuh ke `thumb` (160px) bila
// tidak. Preview bisa kosong untuk lampiran LAMA yang tersimpan sebelum ukuran
// ini ada — dalam kasus itu yang tampil memang buram, dan itu jujur: datanya
// memang tidak pernah disimpan, bukan gagal memuat.

import { useEffect } from 'react';

export default function ImageLightbox({ image, onClose }) {
  // Esc menutup. Listener dipasang di window, bukan pada elemen, supaya tetap
  // bekerja walau fokus sedang di tempat lain (mis. kolom input chat).
  useEffect(() => {
    if (!image) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [image, onClose]);

  if (!image) return null;
  const src = image.preview || image.thumb || '';
  if (!src) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 10000,
        background: 'rgba(15,23,42,0.82)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 24, cursor: 'zoom-out',
      }}
    >
      {/* stopPropagation: klik pada gambar TIDAK menutup — hanya latar yang menutup.
          Tanpa ini, mencoba memperbesar dengan mengeklik justru membubarkan tampilan. */}
      <div onClick={(e) => e.stopPropagation()} style={{ maxWidth: '100%', maxHeight: '100%', cursor: 'default' }}>
        <img
          src={src}
          alt={image.name || 'image'}
          style={{
            maxWidth: '100%', maxHeight: 'calc(100vh - 96px)',
            objectFit: 'contain', borderRadius: 10,
            background: '#fff', display: 'block',
          }}
        />
        <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
          <span style={{ color: '#e2e8f0', fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {image.name || 'image'}
            {/* Penanda jujur bahwa yang tampil bukan resolusi asli, supaya tidak
                ada yang mengira gambarnya rusak saat teks kecil tak terbaca. */}
            {!image.preview && ' · pratinjau kecil (lampiran lama)'}
          </span>
          <button
            onClick={onClose}
            style={{
              border: 'none', background: 'rgba(255,255,255,0.15)', color: '#fff',
              borderRadius: 8, padding: '4px 12px', fontSize: 12, cursor: 'pointer', flexShrink: 0,
            }}
          >
            Esc
          </button>
        </div>
      </div>
    </div>
  );
}
